import React, { useState, useEffect } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Redirect } from 'react-router-dom';
import { useMutation } from 'react-query';

import Button from '../../../components/Button';
import Notification from '../../../utils/notification';
import AuthInput from "../../../components/Form"

import './css/index.css';

export default function InpersonregForm(props) {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [country, setCountry] = useState('Nigeria');
  const [state, setState] = useState('Lagos');
  const [packages, setPackages] = useState('yes');

  const [mutate, { isLoading, data }] = useMutation(async (data) => {
    const response = await fetch(
      'https://testapi.hendrayfinvest.com/user/sign-up/physical-training',
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
        }),
      }
    ).then((res) => res.json());
    return response;
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    await mutate({
      username,
      password,
      state,
      country,
      email,
      phone: phoneNumber,
      package: '2',
      full_name: fullName,
    });
  };

  useEffect(() => {
    if (data && data.error) {
      const dataErrors = data.error;
      Notification.error(
        Object.keys(dataErrors).map((key) => dataErrors[key][0]),
        'error'
      );
    }
  }, [data]);

  return (
    <>
      {data &&
        (data.status ===
          'success' && (
            <Redirect
              to={{
                pathname: '/success',
                state: {
                  email,
                  fullName,
                  phoneNumber,
                  data,
                  from: 'physical-training',
                  price: props.price,
                  packageName: 'Physical in-person training',
                },
              }}
            />
          ))}
      <form onSubmit={onSubmit}>
        <div className="formFle">
          {/* <div className="form-group">
            <label>Enter full name</label>
            <input
              placeholder=""
              value={fullName}
              onChange={(e) => setFullName(e.currentTarget.value)}
              className="formInput"
              type="text"
            />
          </div> */}
          <AuthInput
            placeholder="Hendray Finvest"
            labelTitle="Enter full name"
            value={fullName}
            className="form-group formInput-field"
            name="fullName"
            onChange={(e) => setFullName(e)}
            type="text"
          />
        </div>
        <div className="formFle">
          {/* <div className="form-group">
            <label>Enter Email</label>
            <input
              placeholder=""
              className="formInput"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              type="email"
            />
          </div> */}
          <AuthInput
            placeholder="email@hendrayfinvest.com"
            labelTitle="Enter Email"
            className="formInput-field form-group"
            value={email}
            name="email"
            onChange={(e) => setEmail(e)}
            type="email"
          />
        </div>
        <div className="formFle">
          {/* <div className="form-group">
            <label>Enter Phone number</label>
            <input
              placeholder=""
              className="formInput"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.currentTarget.value)}
              type="tel"
            />
          </div> */}
          <AuthInput
            placeholder="080123456789"
            labelTitle="Enter Phone number"
            value={phoneNumber}
            name="phoneNumber"
            onChange={(e) => setPhoneNumber(e)}
            className="formInput-field form-group"
            type="tel"
          />
        </div>
        <div className="formFle">
          {/* <div className="form-group">
            <label>Preferred Username</label>
            <input
              placeholder=""
              value={username}
              onChange={(e) => setUsername(e.currentTarget.value)}
              className="formInput"
              type="text"
            />
          </div> */}
          <AuthInput
            placeholder="Hendray"
            labelTitle="Preferred Username"
            className="formInput-field form-group"
            value={username}
            name="username"
            onChange={(e) => setUsername(e)}
            type="text"
          />
        </div>
        <div className="formFle">
          {/* <div className="form-group">
            <label>Password</label>
            <input
              placeholder=""
              value={password}
              className="formInput"
              type="password"
              onChange={(e) => setPassword(e.currentTarget.value)}
            />
          </div> */}
          <AuthInput
            placeholder="********"
            labelTitle="Password"
            type="password"
            value={password}
            name="password"
            className="formInput-field form-group"
            onChange={(e) => setPassword(e)}
          />
        </div>
        <div className="formFle left-justified">
          <div className="form-groupp">
            <label>Country</label> <br />
            <select
              value={country}
              onChange={(e) => setCountry(e.currentTarget.value)}
              className="formInput selectForm"
            >
              <option value="Nigeria">Nigeria</option>
              <option value="United States">United States</option>
              <option value="Biafra">Biafra</option>
            </select>
          </div>
          <div className="form-groupp">
            <label className="">State</label> <br />
            <select
              value={state}
              onChange={(e) => setState(e.currentTarget.value)}
              className="formInput selectForm"
            >
              <option value="lagos">Lagos State</option>
              <option value="lagos">Lagos State</option>
              <option value="lagos">Lagos State</option>
            </select>
          </div>
        </div>
        <div className="formFle">
          <div className="form-group">
            <label className="">Package</label> <br />
            <select
              value={packages}
              onChange={(e) => setPackages(e.currentTarget.value)}
              className="formInput selectForm2"
            >
              <option value="yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>
        <div className="formFle topAcc">
          <Button className="acc-submit">
            <div style={{ color: '#fff' }}>
              {isLoading && <CircularProgress size={20} color="inherit" />}
            </div>
            {!isLoading && <span>Proceed</span>}
          </Button>
        </div>
      </form>
    </>
  );
}
